import { Switch } from "@/components/ui/switch";
import {
  createMonitoringIcon,
  MONITORING_BADGE_STYLES,
  type MonitoringType,
} from "@/constants/monitoring";

interface ApiKeyCardProps {
  apiKeyPreview: string;
  monitoringType: MonitoringType;
  isPremium: boolean;
  isChecked: boolean;
  isHighlighted: boolean;
  isDisabled: boolean;
  onToggle: () => void;
}

export function ApiKeyCard({
  apiKeyPreview,
  monitoringType,
  isPremium,
  isChecked,
  isHighlighted,
  isDisabled,
  onToggle,
}: ApiKeyCardProps) {
  const colorClass = isPremium
    ? "bg-yellow-500"
    : MONITORING_BADGE_STYLES[monitoringType] || "bg-gray-500";

  const icon = isPremium ? (
    <i className="ri-star-line text-md text-white" />
  ) : (
    createMonitoringIcon(monitoringType, "text-md", true)
  );

  const borderClass = isHighlighted
    ? "border-orange-500 bg-orange-50"
    : "border-neutral-200 bg-white";

  return (
    <div
      className={`flex flex-col gap-3 rounded-lg border-2 p-4 transition-all ${borderClass}`}
    >
      <div className="flex w-full items-center gap-2">
        <div
          className={`flex h-[28px] w-[28px] flex-shrink-0 items-center justify-center rounded-[8px] ${colorClass} p-2 font-medium text-white transition-transform duration-200 hover:scale-105`}
        >
          <div className="flex items-center justify-center text-[20px]">
            {icon}
          </div>
        </div>
        <div className="line-clamp-2 w-full min-w-0 flex-1 text-xs leading-4 font-semibold -tracking-wide break-words text-neutral-950">
          {apiKeyPreview}
        </div>

        <Switch
          checked={isChecked}
          disabled={isDisabled}
          onCheckedChange={onToggle}
        />
      </div>
    </div>
  );
}
